import styled from 'styled-components';

export const CheckTransportContainer = styled.section`
  background: ${({ theme }) => theme.colors.riceFlower};
  padding: 18px 17px 26px 17px;
  margin-top: 45px;
  border-radius: 8px;

  &.not-checking-options {
    background: ${({ theme }) => theme.colors.weakBlue};
  }

  @media (max-width: 512px) {
    border-radius: 0px;
    padding: 16px 8px 16px 8px;

    .check-list {
      display: none;
    }

    && .button {
      width: 100%;

      a {
        width: 100%;
      }

      button {
        width: 100%;
      }
    }

    &.no-comment {
      margin-top: 12px;
    }
  }
`;

export const Header = styled.div`
  font-size: 20px;

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.xn};
  }
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.fontSize.nm};
  max-width: 655px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.sm};

    & .check-link {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }
`;

export const CheckParams = styled.div`
  margin: 10px 0 0 0;
  line-height: 2;

  table {
    margin-bottom: 12px;
  }
`;

export const CheckParamTitle = styled.td`
  font-size: ${({ theme }) => theme.fontSize.nm};
  color: ${({ theme }) => theme.colors.limedSpruceLight};
  width: 84px;

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const CheckParamDescription = styled.td`
  font-size: ${({ theme }) => theme.fontSize.nm};
  font-weight: bold;
  padding-left: 15px;

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const CheckTitle = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: normal;
`;

export const BrandName = styled.td`
  font-size: ${({ theme }) => theme.fontSize.md};
  margin-top: 10px;
`;

export const HR = styled.hr`
  border-color: rgba(57, 68, 79, 0.1);
  border-top: none;
  margin: 20px -17px 0 -17px;
`;

export const DescriptionContainer = styled.div`
  margin: 14px 0;

  @media (max-width: 512px) {
    .second-paragraph {
      display: none;
    }
  }
`;

export const LinkContainer = styled.div`
  margin-top: 12px;

  @media (max-width: 512px) {
    text-align: center;
  }
`;

export const ExplainDescription = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.regent};
  font-weight: normal;
`;

export const ButtonContainer = styled.div``;
